export default {
  namespaced: true,
  state: {
    lastTab: 'Live',
    lastId: '',
    lastPosition: '',
    visitTimes: 0,
    currentPage: 1,
    hasNext: 0,
    // 美元化项目开关 是否打开 - 默认打开
    isDollarEnabled: true,
    // 价格显示开关 用于控制括号价格、划价、折扣标签 显示或隐藏用（主要用于socket推过来的商品处理，其他地方都已经被服务端处理过）
    priceSwitchStatus: {
      // 上架价格（括号里的价格）
      "showShelf": 0,
      // 划价
      "showOrigin": 0,
      // 折扣字符串
      "showDiscount": 0
    }
  },
  mutations: {
    updateLastTab (state, val) {
      state.lastTab = val
    },
    updateLastId (state, id) {
      state.lastId = id
    },
    updateLastPosition (state, val) {
      state.lastPosition = val
    },
    addVisitTimes (state, val) {
      state.visitTimes += val
    },
    updateCurrentPage (state, val) {
      state.currentPage = val
    },
    updateHasNext (state, val) {
      state.hasNext = val
    },
    setDollarEnabledStatus( state, val ){
      state.isDollarEnabled = val;
    },
    setPriceSwitchStatus(state , val){
      state.priceSwitchStatus = val;
    }
  }
}
